import React from 'react';
import PropTypes from 'prop-types';
import ProgressOverlay from '../common/ProgressOverlay';

export default class BTButtonDetails extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            details: null
        };
    }

    componentDidMount() {
        const { ravenUuid, stage, dataStore } = this.props;
        if(ravenUuid) {
            dataStore.getBTButtonStatus(stage, ravenUuid)
                .then((response) => {
                    this.setState({ details: response });
                })
                .catch((error) => {
                    console.error("Error fetching BT button details:", error);
                })
                .finally(() => {
                    this.setState({ loading: false });
                });
        }
    }

    componentDidUpdate(prevProps) {
        
    }

    renderDetails(details) {
        if (!details) {
            return <p>No BT Button details available</p>;
        }

        if(details.bluetooth_button_enabled === false) {
            return <p>BT Button is disabled</p>;
        }

        if(!details.bluetooth_button_id || details.bluetooth_button_id === 'none') {
            return (
                <div>
                    <p>Not connected to a BT button</p>
                    <button type='button' className='btn btn-sm' onClick={this.enterPairingMode} >Enter Pairing Mode</button>
                </div>
            );
        }

        return (
            <div>
                <p>Paired with {details.bluetooth_button_id}</p>
                <button type='button' className='btn btn-sm' onClick={this.unPair} >Unpair</button>
            </div>
        );

    }

    render () {

        return (
            <div>
                <h3>BT button</h3>
                <div className='bt-button-details'>
                    {this.state.loading ? (
                        <ProgressOverlay />
                    ) : (
                        <div>
                            {this.renderDetails(this.state.details)}
                        </div>
                    )}
                </div>
            </div>
        )
    }

}

BTButtonDetails.propTypes = {
    dataStore: PropTypes.object.isRequired,
    ravenUuid: PropTypes.string.isRequired,
    stage: PropTypes.string.isRequired
};
